import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Grid, Paper, Tooltip, Typography } from '@mui/material';
import WebRoundedIcon from '@mui/icons-material/WebRounded';
import useAPI from '../../../../api';
import renderFromStructure from '../../Utils/renderFromStructure';
import findUnknownElement from '../../Utils/findUnknownElement';
import '../css/structure-select.scss';
import decodeBase64Auto from '../../../../Helpers/decode';
const styles = {
  item: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    borderRadius: 5,
    cursor: 'pointer',
    overflow: 'hidden',
  },
  root: {
    width: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',
    p: '0% 2% 2% 2%',
    height: '100%',
    margin: 0,
  },
};

const StructuresSelect = function StructuresSelect({
  handleSelectStructure = () => {},
  scope,
}) {
  const intl = useIntl();
  const API = useAPI();
  const [structures, setStructures] = useState([]);

  useEffect(() => {
    API.getStructuresTemplates(
      scope,
      (res) => {
        setStructures(res);
      },
      () => {}
    );
  }, []);

  return (
    <Grid container spacing={4} sx={styles.root}>
      {structures.map(({ id, name, content }) => {
        const body = JSON.parse(decodeBase64Auto(content));
        const unknown = findUnknownElement(body);
        return (
          <Grid
            key={id}
            size={{ xl: 4, lg: 4, md: 4, sm: 6, xs: 6 }}
            sx={{
              overflow: 'hidden',
              padding: '8px',
              height: '40%',
            }}
          >
            <Tooltip
              title={
                unknown
                  ? intl.formatMessage(
                      { id: 'UNKNOWN_TEMPLATE_ELEMENT' },
                      { type: unknown.type, position: unknown.path.join(' › ') }
                    )
                  : ''
              }
              followCursor
            >
              <Paper
                sx={
                  unknown
                    ? { ...styles.item, opacity: 0.5, cursor: 'not-allowed' }
                    : styles.item
                }
                elevation={3}
                onClick={
                  unknown
                    ? undefined
                    : () => handleSelectStructure({ id, body })
                }
              >
                <div className="preview-container">
                  <WebRoundedIcon
                    className="template-name"
                    sx={{
                      color: 'greys.subtitle',
                      fontSize: '4rem',
                      margin: '-20% auto',
                    }}
                  />
                  <Typography
                    className="template-name"
                    noWrap
                    sx={{
                      fontSize: '24px',
                      fontWeight: 400,
                      color: 'greys.subtitle',
                    }}
                  >
                    {name}
                  </Typography>

                  <div className="template-preview">
                    {renderFromStructure({
                      element: body,
                      name,
                    })}
                  </div>
                </div>
              </Paper>
            </Tooltip>
          </Grid>
        );
      })}
    </Grid>
  );
};

StructuresSelect.propTypes = {
  handleSelectStructure: PropTypes.func,
  scope: PropTypes.string.isRequired,
};
export default StructuresSelect;
